module.exports = __webpack_public_path__ + "static/media/logo-full-dark.9f7e50f2.png";